import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet-async";

export default function Home() {
  return (
    <>
      <Helmet>
        <title>
          Fahrlux Hanau, Chauffeur & Limousine Service in Hanau | Taxi
          Alternative & Uber Partner
        </title>
        <meta
          name="description"
          content="Fahrlux Hanau offers professional chauffeur and limousine services, airport transfers, and private rides. Your reliable taxi alternative in Hanau and across Germany."
        />
      </Helmet>
      <section
        className="min-vh-100 position-relative d-flex align-items-center text-white"
        style={{
          backgroundImage: "url('/images/image1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflow: "hidden",
        }}
        aria-label="Chauffeur and limousine service in Hanau – taxi alternative and Uber partner"
      >
        {/* Gradient overlay */}
        <div
          aria-hidden="true"
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(180deg, rgba(5,8,12,0.85) 0%, rgba(5,8,12,0.88) 40%, rgba(5,8,12,0.92) 100%)",
          }}
        />

        <div className="container position-relative py-5">
          <div className="row align-items-center">
            <div className="col-12 col-lg-8">
              {/* BRAND */}
              <span
                className="text-uppercase"
                style={{
                  fontSize: "0.9rem",
                  letterSpacing: "0.2em",
                  color: "#C8A968",
                  backgroundColor: "rgba(200, 169, 104, 0.10)",
                  padding: "6px 14px",
                  borderRadius: "999px",
                  display: "inline-block",
                  border: "1px solid rgba(200, 169, 104, 0.25)",
                  position: "relative",
                  overflow: "hidden",
                  animation: "fadeSlide 1.2s ease-out, goldPulse 3s infinite",
                }}
              >
                Fahrlux Hanau
              </span>

              {/* SEO H1 (ONLY ONE, VERY IMPORTANT) */}
              <h1
                className="display-4 fw-semibold mb-3"
                style={{
                  lineHeight: 1.1,
                  textShadow: "0 2px 16px rgba(0,0,0,0.55)",
                }}
              >
                Chauffeur & Limousine Service in Hanau – Taxi Alternative & Uber
                Partner
              </h1>

              {/* SEO DESCRIPTION */}
              <p
                className="lead mb-4"
                style={{ maxWidth: 760, color: "rgba(255,255,255,0.88)" }}
              >
                Fahrlux Hanau provides professional chauffeur and limousine
                services, including airport transfers and private rides. A
                reliable alternative to taxis in Hanau and surrounding areas.
              </p>

              {/* CTAs */}
              <div className="d-flex flex-wrap gap-3 mb-4">
                <a
                  href="/contact"
                  className="btn btn-lg px-4 shadow"
                  style={{
                    borderRadius: 999,
                    backgroundColor: "#C8A968",
                    border: "1px solid #C8A968",
                    color: "#0B0F14",
                    fontWeight: 600,
                  }}
                >
                  Order Now
                </a>

                <a
                  href="/#"
                  className="btn btn-lg px-4"
                  style={{
                    borderRadius: 999,
                    border: "1px solid rgba(255,255,255,0.5)",
                    color: "#ffffff",
                    backgroundColor: "transparent",
                  }}
                >
                  Discover Services
                </a>
              </div>

              {/* SEO SUPPORT TEXT (H2) */}
              <h2 style={{ fontSize: "1.2rem", marginBottom: "8px" }}>
                Taxi Alternative in Hanau
              </h2>

              <p
                style={{ color: "rgba(255,255,255,0.75)", fontSize: "0.95rem" }}
              >
                Looking for a taxi in Hanau? Fahrlux is a professional chauffeur
                and private hire service offering a reliable alternative to
                traditional taxis. We provide pre-booked, high-quality
                transportation with experienced drivers and premium vehicles for
                safe and comfortable travel. Our services are available in
                Hanau, across Germany, and for selected long-distance and
                cross-border trips throughout Europe.
              </p>

              {/* TRUST BADGES */}
              <div
                className="d-flex flex-wrap align-items-center mt-4"
                style={{ gap: 24 }}
              >
                <Badge icon={StarIcon} text="5-Star Service" />
                <a
                  href="/#"
                  className="d-flex align-items-center"
                  style={{
                    gap: 10,
                    textDecoration: "none",
                    color: "rgba(255,255,255,0.9)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#C8A968";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "rgba(255,255,255,0.9)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <PlaneIcon />
                  <span>Limousine Service</span>
                </a>{" "}
                <a
                  href="/"
                  className="d-flex align-items-center"
                  style={{
                    gap: 10,
                    textDecoration: "none",
                    color: "rgba(255,255,255,0.9)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#C8A968";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "rgba(255,255,255,0.9)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <PlaneIcon />
                  <span>Airport Transfers Frankfurt</span>
                </a>{" "}
                <Badge icon={ClockIcon} text="24/7 Availability" />
              </div>
            </div>

            {/* RIGHT SLIDER */}
            <div className="col-12 col-lg-4 mt-4 mt-lg-0">
              <OwnerSlider />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

/* ---------------- BADGE ---------------- */
function Badge({ icon: Icon, text }) {
  return (
    <div className="d-flex align-items-center" style={{ gap: 10 }}>
      <Icon />
      <span style={{ color: "rgba(255,255,255,0.9)" }}>{text}</span>
    </div>
  );
}

/* ---------------- ICONS ---------------- */
function StarIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#C8A968">
      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
    </svg>
  );
}
function ShieldIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#C8A968">
      <path d="M12 2l7 4v6c0 5-3.5 9.74-7 10-3.5-.26-7-5-7-10V6l7-4z" />
    </svg>
  );
}
function ClockIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#C8A968">
      <path d="M12 1a11 11 0 100 22 11 11 0 000-22zm1 11.27l4.2 2.52-.75 1.23L11 13V6h2v6.27z" />
    </svg>
  );
}
function PlaneIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="#C8A968">
      <path d="M2.5 19l8.5-7-8.5-7 9 5 9-5-4 7 4 7-9-5-9 5z" />
    </svg>
  );
}

/* ---------------- SLIDER ---------------- */
// function OwnerSlider() {
//   const people = [
//     {
//       name: "Fardin Azimi",
//       role: "Founder",
//       img: "/images/founder.png",
//       tag: "Founder",
//     },
//     {
//       name: "Abdul Wahab Wojdan",
//       role: "Managing Director",
//       img: "/images/founderw.png",
//       tag: "Driver",
//     },
//     {
//       name: "Customer Support",
//       role: "Client Service",
//       img: "/images/support.jpg",
//       tag: "Support",
//     },
//   ];

//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const id = setInterval(() => {
//       setIndex((prev) => (prev + 1) % people.length);
//     }, 5000);
//     return () => clearInterval(id);
//   }, []);

//   const current = people[index];

//   return (
//     <div style={{ maxWidth: 360 }}>
//       <div
//         style={{
//           background: "rgba(12,16,22,0.45)",
//           border: "1px solid rgba(200,169,104,0.35)",
//           borderRadius: 16,
//         }}
//       >
//         <img
//           src={current.img}
//           alt={current.name}
//           style={{ width: "100%", height: 260, objectFit: "cover" }}
//         />
//         <div className="p-3">
//           <h3 className="h5">{current.name}</h3>
//           <p style={{ color: "rgba(255,255,255,0.7)" }}>{current.role}</p>
//         </div>
//       </div>
//     </div>
//   );
// }

function OwnerSlider() {
  const people = [
    {
      name: "Fardin Azimi",
      role: "Founder",
      img: "/images/founder.png",
    },
    {
      name: "Abdul Wahab Wojdan",
      role: "Managing Director",
      img: "/images/founderw.png",
    },
    {
      name: "Customer Support",
      role: "Client Service",
      img: "/images/support.jpg",
    },
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % people.length);
    }, 5000);

    return () => clearInterval(id);
  }, []);

  const current = people[index];

  return (
    <div className="w-100 px-2 px-md-0">
      <div
        style={{
          background: "rgba(12,16,22,0.45)",
          border: "1px solid rgba(200,169,104,0.35)",
          borderRadius: 16,
          overflow: "hidden",
          maxWidth: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            aspectRatio: "3 / 4",
            overflow: "hidden",
          }}
        >
          <img
            src={current.img}
            alt={current.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>

        <div className="p-3 text-center text-white">
          <h3 className="h5 mb-1">{current.name}</h3>
          <p className="mb-0" style={{ color: "rgba(255,255,255,0.7)" }}>
            {current.role}
          </p>
        </div>
      </div>
    </div>
  );
}
